import React, { useEffect, useState } from 'react';
import { reportProps } from './StopLossAggregateTable';
import PptReportTable from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/PptReportTable';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  CardComponent,
  NoDataVisual,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Grid } from '@mui/material';
import { numberToCurrencyFormatter } from '../core-utils/helper-utils/helper';

export const cellStyles1 = {
  width: '70px',
  color: `${patientAccessTheme.palette.text.highemphasis} !important`,
  paddingLeft: '20px',
  fontSize: '13px',
  fontWeight: 400,
  lineHeight: '21px',
  borderRight: '1px solid white',
  borderBottom: '4px solid white !important',
  backgroundColor: patientAccessTheme.palette.grey[300],
};

export const headerStyles1 = {
  width: '70px',
  color: `${patientAccessTheme.palette.status.white} !important`,
  paddingLeft: '20px',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '19.8px',
  borderRight: '1px solid white',
  borderBottom: '4px solid white !important',
  backgroundColor: patientAccessTheme.palette.grey[700],
};

const ClaimantsDistribution: React.FC<reportProps> = ({ data }) => {
  const [claimantsDistData, setClaimantsDistData] = useState<any>([]);
  const [topClaimants, setTopClaimants] = useState<any>([]);

  const claimantsDistributionColumns: any[] = [
    { name: 'CATEGORY', align: 'left' },
    { name: 'COST RANGE', align: 'left' },
    { name: 'MEMBERS', align: 'left' },
    { name: 'TOTAL COST', align: 'right' },
    { name: 'PLAN PAID', align: 'right' },
    { name: 'MEMBER PAID', align: 'right' },
  ];

  const topClaimantsColumns: any[] = [
    {
      name: 'MEMBER ID',
      align: 'left',
    },
    {
      name: 'GENDER',
      align: 'left',
    },
    {
      name: 'AGE',
      align: 'left',
    },
    {
      name: 'RELATIONSHIP',
      align: 'left',
    },
    {
      name: 'PLAN PAID',
      align: 'right',
    },
    {
      name: 'DIAGNOSIS',
      align: 'left',
      width: '400px',
    },
  ];

  const formatClaimantsDistData = (data: any) => {
    return data?.map((item: any) => {
      return [
        item.category,
        item.costRange,
        item.memberCount,
        numberToCurrencyFormatter(item.totalCost, true, 0),
        numberToCurrencyFormatter(item.planPaid, true, 0),
        numberToCurrencyFormatter(item.memberPaid, true, 0),
      ];
    });
  };

  const formatTopClaimants = (data: any) => {
    const topClaimants = data?.find((temp: any) => temp.category === 'Top 10%')[
      'members'
    ];
    const formattedClaimants = topClaimants?.slice(0, 5)?.map((item: any) => {
      return [
        item.member_unique_id,
        item.gender,
        item.age,
        item.relationship,
        numberToCurrencyFormatter(item.planPaid, true, 0),
        item.diagnosis.map((value: any, index: number) => {
          return `${value.diagnosis_desc}${
            index < item.diagnosis.length - 1 ? '|' : ''
          }`;
        }),
      ];
    });
    return formattedClaimants;
  };

  useEffect(() => {
    setClaimantsDistData(formatClaimantsDistData(data?.claimantsDistribution));
    setTopClaimants(formatTopClaimants(data?.claimantsDistribution));
  }, []);
  return (
    <Grid
      style={{
        width: '72%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <CardComponent
        title={'Claimants Distribution'}
        body={
          claimantsDistData?.length > 0 ? (
            <PptReportTable
              data={claimantsDistData}
              columns={claimantsDistributionColumns}
              cellStyles={cellStyles1}
              headerStyles={headerStyles1}
            />
          ) : (
            <NoDataVisual content="No Data available" height="100%" />
          )
        }
        height="30%"
      />
      <CardComponent
        title={'Top High Cost Claimants'}
        body={
          topClaimants?.length > 0 ? (
            <PptReportTable
              data={topClaimants}
              columns={topClaimantsColumns}
              cellStyles={cellStyles1}
              headerStyles={headerStyles1}
            />
          ) : (
            <NoDataVisual content="No Data available" height="100%" />
          )
        }
        height="65%"
      />
    </Grid>
  );
};
export default ClaimantsDistribution;
